import type { JSONContent } from "@tiptap/core";

export const parseStringIntoJSONContent = (content: string | JSONContent) => {
  if (typeof content !== "string") return content;
  const parts = content.split("\n").filter((p) => p.trim() !== "");
  const jsonContent: JSONContent = {
    type: "doc",
    content: [],
  };
  for (const part of parts) {
    jsonContent.content?.push({
      type: "paragraph",
      content: part ? [{ type: "text", text: part }] : [],
    });
  }
  return jsonContent;
};
